import { render, staticRenderFns } from "./AllMyProducts.vue?vue&type=template&id=741a2716&"
import script from "./AllMyProducts.vue?vue&type=script&lang=js&"
export * from "./AllMyProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports